

import objectAssign from 'object-assign'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import "babel-polyfill";


import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import "babel-polyfill"; 
Vue.config.productionTip = false
Vue.use(Vuex)

import versionTood from './libs/versionUpdate'

import store from './vuex/store'
Vue.prototype.$store = store


import Icon from 'vue-svg-icon/Icon.vue';
Vue.component('icon', Icon);

Vue.prototype.bus=new Vue();
require('es6-promise').polyfill()

/** i18n **/








const vuxLocales = require('json-loader!yaml-loader!./locales/all.yml')
const componentsLocales = require('json-loader!yaml-loader!./locales/components.yml')

const finalLocales = {
'en': objectAssign(vuxLocales['en'], componentsLocales['en']),
'zh-CN': objectAssign(vuxLocales['zh-CN'], componentsLocales['zh-CN'])
}





import DevicePlugin from 'vux/src/plugins/device/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LocalePlugin from 'vux/src/plugins/locale/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'


Vue.use(LocalePlugin)
const nowLocale = Vue.locale.get()






store.registerModule('vux', {
state: {
demoScrollTop: 0,
isLoading: false,
direction: 'forward'
},
mutations: {
updateDemoPosition (state, payload) {
state.demoScrollTop = payload.top
},
updateLoadingStatus (state, payload) {
state.isLoading = payload.isLoading
},
updateDirection (state, payload) {
state.direction = payload.direction
}
},
actions: {
updateDemoPosition ({commit}, top) {
commit({type: 'updateDemoPosition', top: top})
}
}
})

import { Cookie } from './js/common';

router.beforeEach((to, from, next) => {
versionTood.isNewVersion()
/*
if (to.path == '/auth') {
Cookie.Set('token','');
}
*/
var user = Cookie.Get('token');
if(process.env.NODE_ENV =='development'){



}









if (!user && to.path.substr(0,8) != '/AuthApp') {
next({ path: '/AuthApp' })
} else {
next()
}
})



Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(DevicePlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(WechatPlugin)

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js